import React from 'react';
import { MEDIA_CONFIG } from '../data/media';

function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white pt-20">
      {/* Hero Section */}
      <div className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <img
          src={`${MEDIA_CONFIG.paths.backgrounds}/headers/privacy-header.jpg`}
          alt="Datenschutz Header"
          className="absolute w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Datenschutzerklärung</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Informationen zum Umgang mit Ihren Daten
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">Allgemeiner Hinweis und Pflichtinformationen</h2>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Benennung der verantwortlichen Stelle</h3>
              <p className="text-gray-300">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                Jan Ctvrtnicek - HonzaMedia<br />
                Jan Ctvrtnicek<br />
                Detmolder Straße 53<br />
                33813 Oerlinghausen<br />
                E-Mail: info@honzamedia.de<br />
                Telefon: +49 179-4323436<br /><br />
                Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p className="text-gray-300">
                Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</h3>
              <p className="text-gray-300">
                Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Recht auf Datenübertragbarkeit</h3>
              <p className="text-gray-300">
                Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h3>
              <p className="text-gray-300">
                Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft, Empfänger und Zweck der Datenverarbeitung. Zudem haben Sie das Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum aufgeführten Kontaktmöglichkeiten an uns wenden.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">SSL- bzw. TLS-Verschlüsselung</h3>
              <p className="text-gray-300">
                Unsere Website nutzt eine SSL- bzw. TLS-Verschlüsselung. Dadurch sind Daten, die Sie über diese Website übermitteln, für Dritte nicht mitlesbar. Eine verschlüsselte Verbindung erkennen Sie an der „https://" Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Server-Log-Dateien</h3>
              <p className="text-gray-300">
                Der Provider unserer Website erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-300 space-y-2">
                <li>Besuchte Seite auf unserer Domain</li>
                <li>Datum und Uhrzeit der Serveranfrage</li>
                <li>Browsertyp und Browserversion</li>
                <li>Verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>IP-Adresse</li>
              </ul>
              <p className="mt-4 text-gray-300">
                Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Kontaktformular</h3>
              <p className="text-gray-300">
                Per Kontaktformular übermittelte Daten werden inklusive Ihrer Kontaktdaten gespeichert, um Ihre Anfrage bearbeiten zu können oder um für Anschlussfragen bereitzustehen. Eine Weitergabe dieser Daten findet ohne Ihre Einwilligung nicht statt.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Drittanbieter-Dienste</h3>
              <p className="text-gray-300">
                Diese Website nutzt Dienste externer Anbieter, darunter:
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-300 space-y-2">
                <li>Vimeo für die Einbettung von Videos (Datenschutzerklärung)</li>
                <li>Google Analytics zur Analyse der Website-Nutzung (Datenschutzerklärung)</li>
                <li>Google Maps zur Darstellung von Karten (Datenschutzerklärung)</li>
                <li>Google reCAPTCHA zur Erkennung von Bots (Datenschutzerklärung)</li>
              </ul>
              <p className="mt-4 text-gray-300">
                Die Nutzung dieser Dienste erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Aktualität und Änderung dieser Datenschutzerklärung</h3>
              <p className="text-gray-300">
                Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder geänderte gesetzliche Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Privacy;